module.exports = __webpack_public_path__ + "static/media/GLIDE-Logo.ac57dfce.png";